import React from 'react';

import { makeStyles } from 'tss-react/mui';

import { Typography } from '@hbf/dsl/core';
import { Star } from '@hbf/icons/brand-fill';

import { getIsNorthAmericanCountryName } from 'ha/utilities/isNorthAmerican';

import { useIntl } from 'ha/i18n';
import { ListingCardModel } from 'ha/models/Listing/types';

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.utils.spacing('ref/spacing/1'),
    justifyContent: 'flex-end',
  },

  icon: {
    color: theme.palette.warning.main,
    fontSize: '16px', // TODO: replace with correct icon utility
  },
}));

export const ListingCardDetailsRating = React.memo(
  ({ listing }: { listing: ListingCardModel }) => {
    const { formatNumber } = useIntl();
    const { classes } = useStyles();

    const moveInOverallRating =
      listing.advertiser.moveInRatingAll?.overall ??
      listing.advertiser.moveInRating?.overall;

    const moveInReviewCount =
      listing.advertiser.moveInRatingAll?.reviewCount ??
      listing.advertiser.moveInRating?.reviewCount;

    if (!moveInOverallRating || !moveInReviewCount) {
      return null;
    }

    if (moveInReviewCount < 3 && moveInOverallRating < 3) {
      return null;
    }

    if (getIsNorthAmericanCountryName(listing.location.country.en)) return null;

    return (
      <div className={classes.container}>
        <Star className={classes.icon} />

        <Typography
          variant="body/sm-regular"
          data-test-locator="ListingCard/Rating"
        >
          {formatNumber(moveInOverallRating, {
            maximumFractionDigits: 1,
          })}
          &nbsp;
          {`(${formatNumber(moveInReviewCount)})`}
        </Typography>
      </div>
    );
  },
);
